// extracted by mini-css-extract-plugin
module.exports = {"activitiesLoading":"LoadingActivitiesList_activitiesLoading__sN0Ar"};